import {
    GET_CONFIG_FORM41,
    GET_DATOS_GESTION,
    GET_COMBO_AMBITO_GESTION,
    GET_COMBO_INSTANCIA_GESTION,
    GET_COMBO_MODO_CONTACTO,
    GET_DATOS_CONTACTO,
    GET_COMBO_RESPUESTA_CONTACTO,
    OBTENER_LLAVES,
    POST_RECEPCION
    
} from '../types';


export default function recepcionaCasoReducer(state = {}, action) {
    switch (action.type) {
        case GET_CONFIG_FORM41:
            return { ...state, cfg_form41:action.payload }
        case GET_DATOS_GESTION:
            return { ...state, datosGestion:action.payload }
        case GET_COMBO_AMBITO_GESTION:
            return { ...state, comboAmbitoGestion:action.payload }
        case GET_COMBO_INSTANCIA_GESTION:
            return { ...state, comboInstanciaGestion:action.payload }
        case GET_COMBO_MODO_CONTACTO:
            return { ...state, comboModoContacto:action.payload }
        case GET_COMBO_RESPUESTA_CONTACTO:
            return { ...state, comboRespuestaContacto:action.payload }
        case GET_DATOS_CONTACTO:
            return { ...state, datosContactoTercero:action.payload }
        case OBTENER_LLAVES:
            return { ...state, llaves: action.payload }
        case POST_RECEPCION:
            return { ...state, respuestaRecepcion: action.payload }
       
        default:
            return state
    }
}